import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { API_BASE_URL } from '../../config.js';

const Gatepass = ({ fixNavbar }) => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);

  const emptyForm = {
    from_date: '',
    to_date: '',
    type: 'IN',
    pass_time: '',
    reason: '',
  };
  const [form, setForm] = useState(emptyForm);

  const authHeader = {
    headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
  };

  /* ================= FETCH DATA ================= */
  const loadData = () => {
    axios
      .get(API_BASE_URL + '/gatepass_list', authHeader)
      .then((res) => setData(res.data || []))
      .catch(() => toast.error('Failed to load gate pass list'));
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ================= SEARCH ================= */
  const filteredData = data.filter((item) =>
    `${item.employee_name}${item.emp_code}${item.department_name}${item.from_date}${item.to_date}${item.reason}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= FORM HANDLERS ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const openModal = () => {
    setForm(emptyForm);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setForm(emptyForm);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !form.from_date ||
      !form.to_date ||
      !form.type ||
      !form.pass_time ||
      !form.reason
    ) {
      toast.error('Please fill all required fields');
      return;
    }
    if (form.to_date < form.from_date) {
      toast.error('To Date cannot be before From Date');
      return;
    }

    setSaving(true);
    axios
      .post(API_BASE_URL + '/gatepass_add', form, authHeader)
      .then((res) => {
        if (res.data && res.data.status === 200) {
          toast.success(res.data.message || 'Gate pass saved successfully');
          closeModal();
          loadData();
        } else {
          toast.error((res.data && res.data.message) || 'Failed to save');
        }
      })
      .catch(() => toast.error('Failed to save gate pass'))
      .finally(() => setSaving(false));
  };

  /* ================= STATUS LABEL ================= */
  const statusBadge = (status) => {
    const s = Number(status);
    if (s === 2)
      return <span className="badge badge-success">Approved</span>;
    return <span className="badge badge-warning">Pending</span>;
  };

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    {
      name: 'S.No',
      selector: (row, index) => index + 1,
      width: '80px',
    },
    {
      name: 'Employee Name',
      selector: (row) => row.employee_name,
      sortable: true,
      grow: 2,
      cell: (row) => (
        <div>
          <div>{row.employee_name}</div>
          <small className="text-muted">{row.emp_code}</small>
        </div>
      ),
    },
    {
      name: 'Department',
      selector: (row) => row.department_name || '-',
      sortable: true,
      wrap: true,
      grow: 2,
      minWidth: '160px',
    },
    {
      name: 'From Date',
      selector: (row) => row.from_date,
      sortable: true,
      minWidth: '130px',
    },
    {
      name: 'To Date',
      selector: (row) => row.to_date,
      sortable: true,
      minWidth: '130px',
    },
    {
      name: 'Type',
      selector: (row) => row.type || '-',
      sortable: true,
      width: '90px',
      cell: (row) => (
        <span
          className={
            'badge ' +
            (row.type === 'OUT' ? 'badge-danger' : 'badge-info')
          }
        >
          {row.type || '-'}
        </span>
      ),
    },
    {
      name: 'Time',
      selector: (row) => row.pass_time || '-',
      sortable: true,
      width: '100px',
    },
    {
      name: 'Reason',
      selector: (row) => row.reason || '',
      sortable: true,
      wrap: true,
      grow: 2,
      cell: (row) => {
        const reason = row.reason || '';
        const shortText =
          reason.length > 5 ? reason.substring(0, 5) + '...' : reason;
        return (
          <div className="remark-hover-wrapper">
            {shortText}
            <div className="remark-hover-box gp-scroll gp-left">{reason}</div>
          </div>
        );
      },
    },
    {
      name: 'Status',
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => statusBadge(row.status),
    },
  ];

  return (
    <>
<ToastContainer position="bottom-right" />
      <div className={`section-body ${fixNavbar ? 'marginTop' : ''}`}>
        <div className="container-fluid">
          <div className="card">
            {/* HEADER */}
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="card-title mb-0" style={{ color: '#e96827' }}>
                Gate Pass List
              </h3>

              <div className="d-flex align-items-center">
                <div
                  style={{ position: 'relative', width: '260px' }}
                  className="mr-2"
                >
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ paddingRight: '30px' }}
                  />
                  {searchTerm && (
                    <span
                      onClick={() => setSearchTerm('')}
                      style={{
                        position: 'absolute',
                        top: '50%',
                        right: '10px',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        color: '#aaa',
                        fontSize: '18px',
                      }}
                    >
                      ✖
                    </span>
                  )}
                </div>

                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={openModal}
                >
                  <i className="fe fe-plus mr-1" />
                  Add
                </button>
              </div>
            </div>

            {/* TABLE */}
            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                highlightOnHover
                striped
                responsive
                persistTableHead
                noDataComponent="No gate pass records found"
              />
            </div>
          </div>
        </div>
      </div>

      {/* ================= ADD MODAL ================= */}
      {showModal && (
        <>
          <div className="modal fade show d-block" role="dialog" tabIndex="-1">
            <div className="modal-dialog" role="document">
              <form className="modal-content" onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">Add Gate Pass</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={closeModal}
                  >
                    <span>&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-6 form-group">
                      <label>
                        From Date <span className="text-danger "></span>
                      </label>
                      <DatePicker
                        selected={
                          form.from_date ? new Date(form.from_date) : null
                        }
                        onChange={(date) => {
                          const value = date
                            ? date.toLocaleDateString('en-CA')
                            : '';
                          setForm((prev) => ({
                            ...prev,
                            from_date: value,
                            to_date:
                              prev.to_date && value && prev.to_date < value
                                ? ''
                                : prev.to_date,
                          }));
                        }}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Select From Date"
                        className="form-control required-input"
                      />
                    </div>
                    <div className="col-6 form-group">
                      <label>
                        To Date <span className="text-danger"></span>
                      </label>
                      <DatePicker
                        selected={
                          form.to_date ? new Date(form.to_date) : null
                        }
                        onChange={(date) => {
                          const value = date
                            ? date.toLocaleDateString('en-CA')
                            : '';
                          setForm((prev) => ({ ...prev, to_date: value }));
                        }}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Select To Date"
                        className="form-control required-input"
                        minDate={
                          form.from_date ? new Date(form.from_date) : null
                        }
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 form-group">
                      <label>
                        Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="type"
                        value={form.type}
                        onChange={handleChange}
                      >
                        <option value="IN">IN</option>
                        <option value="OUT">OUT</option>
                      </select>
                    </div>
                    <div className="col-6 form-group">
                      <label>
                        Time <span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        name="pass_time"
                        value={form.pass_time}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>
                      Reason <span className="text-danger"></span>
                    </label>
                    <textarea
                      className="form-control required-input"
                      name="reason"
                      rows="3"
                      value={form.reason}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div
                  className="modal-footer d-flex justify-content-end"
                  style={{ gap: '8px' }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                    disabled={saving}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saving}
                  >
                    {saving ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Gatepass);
